/* eslint-disable @typescript-eslint/no-explicit-any */

export const announcementsRoutes = {
    root: '',
    form: 'announcement',
};

export const announcementsLinks = routesToLinks(announcementsRoutes);

export const screeningsRoutes = {
    root: 'screenings',
    backgroundChecks: 'background-checks',
    credentialVerifications: 'credentials',
};

export const screeningsLinks = routesToLinks(screeningsRoutes);

export const notificationsRoutes = {
    root: 'notifications',
    inbox: 'inbox',
    inboxArchived: 'inbox/archived',
    sent: 'sent',
    drafts: 'drafts',
    templates: 'templates',
    archived: 'archived',
};

export const notificationsLinks = routesToLinks(notificationsRoutes);

export const accountsRoutes = {
    root: 'accounts',
};

export const accountsLinks = routesToLinks(accountsRoutes);

export const groupsRoutes = {
    root: 'groups',
};

export const groupsLinks = routesToLinks(groupsRoutes);

export const organizationRoutes = {
    root: 'organizations',
};

export const organizationLinks = routesToLinks(organizationRoutes);

export const missionsRoutes = {
    root: 'missions',
};

export const missionLinks = routesToLinks(missionsRoutes);

export const timeTrackingRoutes = {
    root: 'time-tracking',
};

export const documentsRoutes = {
    root: 'documents',
};

export const contactUsRoutes = {
    root: 'contact-us',
};

export const reportsRoutes = {
    root: 'reports',
};

export const timeTrackingLinks = routesToLinks(timeTrackingRoutes);

function routesToLinks<T extends { root: string; [key: string]: unknown }>(routes: T, parentRoute = ''): T {
    const links = {} as any;
    const baseRoute = parentRoute + '/' + routes.root;
    for (const [key, value] of Object.entries(routes)) {
        if (typeof value === 'string') {
            if (key === 'root') {
                links[key] = baseRoute;
            } else {
                links[key] = baseRoute + '/' + value;
            }
        } else if (value != null && typeof value === 'object') {
            links[key] = routesToLinks(value as any, baseRoute);
        }
    }
    return links;
}
